import {getTodayReservationList, signReOrder, getTodayReservationStat} from "@/api";
import {ElMessageBox} from "element-plus";
import {message, getTodayDate} from "@/assets/utils/common";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                cardPatientName: '',
                cardPatientPhone: '',
                reSerialNo: '',
                doctorName: ''
            },
            tableLoading: false,
            tableData: [],
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            statData: {
                total: 0,
                waitSign: 0,
                waitVisit: 0,
                visiting: 0,
                done: 0,
                cancel: 0,
                waitPay: 0,
                jumpCall: 0
            },
        }
    },
    computed: {
        todayLabel() {
            const date = new Date();
            const m = date.getMonth() + 1;
            const d = date.getDate();
            const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
            const w = weekDays[date.getDay()];
            return `${m}月${d}日 星期${w}`;
        },
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.multipleTable && this.$refs.multipleTable.$el) {
                this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
            }
        }, 1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        this.getTodayReservationStatInfo();
        this.getTodayReservationListInfo();
    },
    methods: {
        // 查询今日预约统计数据
        getTodayReservationStatInfo() {
            const data = {
                schDate: getTodayDate(),
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
            };
            getTodayReservationStat(data).then(res => {
                const rdata = res.data;
                if (rdata.code === 200 && rdata.data) {
                    const d = rdata.data;
                    this.statData = {
                        total:     d.total     || 0,
                        waitSign:  d.waitSign  || 0,
                        waitVisit: d.waitVisit || 0,
                        visiting:  d.visiting  || 0,
                        done:      d.done      || 0,
                        cancel:    d.cancel    || 0,
                        waitPay:   d.waitPay   || 0,
                        jumpCall:  d.jumpCall  || 0,
                    };
                    this.totalCount = d.total || 0;
                }
            }).catch(() => {});
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.cardPatientPhone = "";
            this.queryParams.reSerialNo = "";
            this.queryParams.keyword = "";
            this.getTodayReservationListInfo();
        },

        // 切换分页
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getTodayReservationListInfo();
        },

        // 切换分页
        handleSizeChange(val) {
            this.pageNums = val;
            this.getTodayReservationListInfo();
        },

        // 查询今日预约列表
        getTodayReservationListInfo() {
            this.tableData = [];
            this.tableLoading = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                schDate: getTodayDate(),
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardPatientPhone: this.queryParams.cardPatientPhone,
                cardPatientName: this.queryParams.cardPatientName,
                reSerialNo: this.queryParams.reSerialNo,
            };
            getTodayReservationList(data).then(res => {
                const rdata = res.data;
                this.tableLoading = false;
                if (rdata.code === 200) {
                    let rows = rdata.rows || [];
                    rows.sort((a, b) => {
                        const timeA = a.reTime || '';
                        const timeB = b.reTime || '';
                        return timeA.localeCompare(timeB);
                    });
                    this.tableData = rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = item.cardPatientBirth ? new Date(item.cardPatientBirth).getFullYear() : null;
                        let nowYear = new Date().getFullYear();
                        item.age = birYear ? parseInt(nowYear - birYear) : '--';
                        item.reTimeTypeText = item.reTimeType === 'am' ? '上午' : item.reTimeType === 'pm' ? '下午' : '晚上';
                        item.reStatusText = item.reStatus === '1' ? '待支付' : item.reStatus === '2' ?
                            '已完成' : item.reStatus === '3' ? '已失效' : item.reStatus === '4' ? '已取消' : item.reStatus === '5' ? '待就诊' : item.reStatus === '6' ? '就诊中' : item.reStatus === '7' ? '已过号' : item.reStatus === '8' ? '待签到' : '未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1') {
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                message(error, "error");
            });
        },

        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        message("签到成功", "success");
                        this.getTodayReservationStatInfo();
                        this.getTodayReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getTodayReservationStatInfo();
                        this.getTodayReservationListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

    }
}
